module.exports = __webpack_public_path__ + "img/level_three_lock.4fcaa21f.png";